import React from 'react'

import { Column } from 'react-table'

import { Loading } from '../../../layouts/Loading'

import { Table } from '../../../components/Table'

import { CellActions, CellPhone, CellText } from './Cells'

import { Accredited } from '../../../@types/entities/entities.types'
import { ModalCreateAccredited } from './Cells/Modal/CreateAccredited'

type AccreditedTableProps = {
  results: Accredited[]
  filter: string
  placeholder?: string
  isLoading: boolean
  isRefetching: boolean
}

export function AccreditedTable({
  results,
  filter,
  placeholder,
  isLoading,
  isRefetching,
}: AccreditedTableProps) {
  const columns = React.useMemo<Column[]>(
    () => [
      {
        Header: 'Nome',
        accessor: 'name',
        Cell: ({ cell: { value } }) => <CellText value={value} />,
      },
      {
        Header: 'Vinculado a',
        accessor: 'monthly_id' ? 'monthly.name' : '',
        Cell: ({ cell: { value } }) => <CellText value={value} />,
      },
      {
        Header: 'Celular',
        accessor: 'phone',
        Cell: ({ cell: { value } }) => <CellPhone value={value} />,
      },
      {
        Header: 'Placa',
        accessor: 'vehicle_license_plate',
        Cell: ({ cell: { value } }) => <CellText value={value} />,
      },
      {
        Header: 'Ações',
        accessor: 'actions',
        Cell: ({ row: { original } }) => <CellActions original={original} />,
      },
    ],
    []
  )

  return (
    <>
      {isLoading ? (
        <Loading width="full" height="full" />
      ) : (
        <Table
          table_name="accredited"
          columns={columns}
          data={results}
          title="Listagem de credenciados"
          addNew={<ModalCreateAccredited />}
          download
          filter={filter}
          placeholder={placeholder}
          isLoading={isLoading}
          isRefetching={isRefetching}
        />
      )}
    </>
  )
}
